import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.less'
import { Dialog } from 'vant'
import config from './common/config'
import tools from './common/tools'
import { handleBuy } from './utils'
import shareLink from './utils/wxShare.js'
import 'amfe-flexible'

Vue.prototype.$handleBuy = handleBuy

Vue.config.productionTip = false

Vue.prototype.$shareLink = shareLink

Vue.use(ElementUI)
Vue.use(Vant)
window.CONFIG = config()
Vue.prototype.$tools = tools
Vue.prototype.$dialog = Dialog

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
